<template>
	<Popup
		v-model="selfDisplay"
		title="新增商品"
		confirmBtnText="新增"
		@confirmClick="handleAddClick"
	>
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>商品名称</span>
				<el-input v-model="name" placeholder="商品名称"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="nameTip"><i class="b_icon"></i>请输入商品名称</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>商品描述</span>
				<el-input v-model="desc" placeholder="商品描述"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="descTip"><i class="b_icon"></i>请输入商品描述</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>商品原价</span>
				<el-input v-model="oldPrice" placeholder="商品原价"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="oldPriceTip"><i class="b_icon"></i>请输入商品原价</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>商品折扣价</span>
				<el-input v-model="price" placeholder="商品折扣价"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="priceTip"><i class="b_icon"></i>请输入商品折扣价</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>商品出厂价</span>
				<el-input v-model="factoryPrice" placeholder="商品出厂价"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="factoryPriceTip"><i class="b_icon"></i>请输入商品出厂价</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>是否虚拟产品</span>
				<div class="b_checkbox_group">
					<el-radio-group v-model="isVirtual">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="2">否</el-radio>
					</el-radio-group>
				</div>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>天数</span>
				<el-input v-model="days" placeholder="请输入天数"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="daysTip"><i class="b_icon"></i>请输入天数</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>次数</span>
				<el-input v-model="times" placeholder="请输入每天训练次数"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="timesTip"><i class="b_icon"></i>请输入每天训练次数</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>训练产品列表</span>
				<el-select v-model="trainingProduct" placeholder="请选择" style="width: 100%;">
					<el-option v-for="v in mallTrainingProduct" :key="v.id" :value="v.id" :label="v.name"></el-option>
				</el-select>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="trainingProductTip"><i class="b_icon"></i>请选择训练产品</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>关联疾病</span>
				<div class="b_checkbox_group">
					<el-checkbox-group v-model="disease">
						<el-checkbox v-for="v in diseaseList" :key="v.id" :label="v.id">{{ v.name }}</el-checkbox>
					</el-checkbox-group>
				</div>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="diseaseTip"><i class="b_icon"></i>请选择关联疾病</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>列表图</span>
				<div v-if="!post" class="b_upload b_inline_block">
					<el-button type="primary">点击上传</el-button>
					<input type="file" accept="image/*" @change="handlePostUpload"/>
					<span class="b_upload_tip">请上传jpg或者png图片！！！</span>
				</div>
				<div v-if="post" class="b_upload b_inline_block" style="border: 1px solid #ccc;">
					<img :src="post" alt="" style="">
					<i @click="handlePostDelete"></i>
				</div>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="postTip"><i class="b_icon"></i>请上传列表图</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>卡片图</span>
				<div v-if="!cardImg" class="b_upload b_inline_block">
					<el-button type="primary">点击上传</el-button>
					<input type="file" accept="image/*" @change="handleCardImgUpload"/>
					<span class="b_upload_tip">请上传jpg或者png图片！！！</span>
				</div>
				<div v-if="cardImg" class="b_upload b_inline_block" style="border: 1px solid #ccc;">
					<img :src="cardImg" alt="" style="">
					<i @click="handleCardImgDelete"></i>
				</div>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="cardImgTip"><i class="b_icon"></i>请上传卡片图</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>轮播图</span>
				<div>
					<div class="b_upload b_inline_block">
						<el-button type="primary">点击上传</el-button>
						<input type="file" accept="image/*" multiple @change="handleCarouselsUpload"/>
						<span class="b_upload_tip">最多上传5张图片！！！</span>
					</div>
				</div>
				<div v-if="carousels.length" style="margin-top: 20px;">
					<div v-for="(v, i) in carousels" :key="i" class="b_upload b_inline_block" style="margin: 0 20px 20px 0;border: 1px solid #ccc;">
						<img :src="carousels[i]" alt="" style="">
						<i @click="handleCarouselsDeleteClick(i)"></i>
					</div>
				</div>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="carouselsTip"><i class="b_icon"></i>请上传至少一张轮播图</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>信息图</span>
				<div>
					<div class="b_upload b_inline_block">
						<el-button type="primary">点击上传</el-button>
						<input type="file" accept="image/*" multiple @change="handleInfoPicUpload"/>
						<span class="b_upload_tip">请上传jpg或者png图片！！！</span>
					</div>
				</div>
				<div v-if="infoPic.length" style="margin-top: 20px;">
					<div v-for="(v, i) in infoPic" :key="i" class="b_upload b_inline_block" style="margin: 0 20px 20px 0;border: 1px solid #ccc;">
						<img :src="infoPic[i]" alt="" style="">
						<i @click="handleInfoPicDelete(i)"></i>
					</div>
				</div>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="infoPicTip"><i class="b_icon"></i>请上传信息图</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>运费</span>
				<el-input v-model="fare" placeholder="运费"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="fareTip"><i class="b_icon"></i>请输入运费</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>月售</span>
				<el-input v-model="monthSale" placeholder="月售"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="monthSaleTip"><i class="b_icon"></i>请输入月售数</template></div>
		</div>
	</Popup>
</template>

<script>
	import Api from '../../../../../../../api/index.js';
	import BaseMethods from '../../../../../../../assets/js/base.js';
	import { mapState } from 'vuex';
	
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			diseaseList: {
				type: Array,
				default() { return []; }
			}
		},
		mounted () {
			this.uploadType = '';
			this.display && (this.selfDisplay = true);
		},
		data () {
			return {
				loading: false,
				selfDisplay: false,
				
				name: '',
				desc: '',
				oldPrice: '',
				factoryPrice: '',
				price: '',
				isVirtual: 1,
				days: '',
				times: '',
				trainingProduct: '',
				disease: [],
				post: '',
				cardImg: '',
				carousels: [],
				infoPic: [],
				fare: '',
				monthSale: '',
				nameTip: false,
				descTip: false,
				oldPriceTip: false,
				factoryPriceTip: false,
				priceTip: false,
				daysTip: false,
				timesTip: false,
				trainingProductTip: false,
				diseaseTip: false,
				postTip: false,
				cardImgTip: false,
				carouselsTip: false,
				infoPicTip: false,
				fareTip: false,
				monthSaleTip: false
			}
		},
		computed: {
			...mapState([
				'mallTrainingProduct'
			])
		},
		methods: {
			// 上传列表图
			handlePostUpload(e) {
				const that = this;
				that.uploadType = 'post';
				BaseMethods.uploadMultiImg(e, (base64, imgs_type, imgs_name) => {
					that.uploadSingleImg(base64[0], imgs_type[0], imgs_name[0]);
				}, (msg) => {
					that.$message.error(msg);
				});
			},
			// 删除上传的列表图
			handlePostDelete() {
				this.post = '';
			},
			// 上传卡片图
			handleCardImgUpload(e) {
				const that = this;
				that.uploadType = 'cardImg';
				BaseMethods.uploadMultiImg(e, (base64, imgs_type, imgs_name) => {
					that.uploadSingleImg(base64[0], imgs_type[0], imgs_name[0]);
				}, (msg) => {
					that.$message.error(msg);
				});
			},
			// 删除上传的卡片图
			handleCardImgDelete() {
				this.cardImg = '';
			},
			// 上传信息图
			handleInfoPicUpload(e) {
				const that = this;
				that.uploadType = 'infoPic';
				BaseMethods.uploadMultiImg(e, (base64, imgs_type, imgs_name) => {
					that.uploadMultipleImg(base64, imgs_type, imgs_name);
				}, (msg) => {
					that.$message.error(msg);
				});
			},
			// 删除上传的信息图
			handleInfoPicDelete(index) {
				this.infoPic.splice(index, 1);
			},
			// 上传轮播图
			handleCarouselsUpload(e) {
				const that = this;
				that.uploadType = 'carousels';
				BaseMethods.uploadMultiImg(e, (base64, imgs_type, imgs_name) => {
					let len = base64.length + that.carousels.length;
					len <= 5
					? that.uploadMultipleImg(base64, imgs_type, imgs_name)
					: that.$message.error('最多只能上传5张图片！');
				}, (msg) => {
					that.$message.error(msg);
				});
			},
			// 删除上传的轮播图
			handleCarouselsDeleteClick(index) {
				this.carousels.splice(index, 1);
			},
			// 上传多张图片
			uploadMultipleImg(base64, img_type, fileName) {
				const that = this;
				let imgsLen = base64.length;
				let imgsList = [];
				that.loading = true;
				_(0);
				
				function _(index) {
					let postName = `${ new Date().getTime() }_${ fileName[index] }`;
					let requestData = {
						base: base64[index],
						picName: postName,
						type: 'uGateWayUrl'
					};
					Api.uploadPic(requestData).then((res) => {
						if (res.data.success) {
							let currentIndex = index + 1;
							imgsList.push(res.data.data.imgUrl);
							if (currentIndex >= imgsLen) {
								that.uploadType == 'infoPic' && (that.infoPic = [...that.infoPic, ...imgsList]);
								that.uploadType == 'carousels' && (that.carousels = [...that.carousels, ...imgsList]);
								that.loading = false;
							} else {
								_(currentIndex);
							}
						} else {
							that.loading = false;
							that.$message.error(res.data.message);
						}
					}, (e) => {
						that.loading = false;
						that.$message.error(e.message);
					});
				}
			},
			// 上传单张图片
			uploadSingleImg(base64, img_type, fileName) {
				const that = this;
				that.loading = true;
				let postName = `${ new Date().getTime() }_${ fileName }`;
				let requestData = {
					base: base64,
					picName: postName,
					type: 'uGateWayUrl'
				};
				Api.uploadPic(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.uploadType == 'post' && (that.post = res.data.data.imgUrl);
						that.uploadType == 'cardImg' && (that.cardImg = res.data.data.imgUrl);
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 点击新增
			handleAddClick() {
				if (!this.name.trim()) {
					this.nameTip = true;
					return false;
				} else {
					this.nameTip = false;
				}
				if (!this.desc.trim()) {
					this.descTip = true;
					return false;
				} else {
					this.descTip = false;
				}
				if (!this.floatReg.test(this.oldPrice)) {
					this.oldPriceTip = true;
					return false;
				} else {
					this.oldPriceTip = false;
				}
				if (!this.floatReg.test(this.factoryPrice)) {
					this.factoryPriceTip = true;
					return false;
				} else {
					this.factoryPriceTip = false;
				}
				if (!this.floatReg.test(this.price)) {
					this.priceTip = true;
					return false;
				} else {
					this.priceTip = false;
				}
				if (!this.positiveReg.test(this.days)) {
					this.daysTip = true;
					return false;
				} else {
					this.daysTip = false;
				}
				if (!this.positiveReg.test(this.times)) {
					this.timesTip = true;
					return false;
				} else {
					this.timesTip = false;
				}
				if (parseInt(this.trainingProduct) >= 0) {
					this.trainingProductTip = false;
				} else {
					this.trainingProductTip = true;
					return false;
				}
				if (!this.disease.length) {
					this.diseaseTip = true;
					return false;
				} else {
					this.diseaseTip = false;
				}
				if (!this.post) {
					this.postTip = true;
					return false;
				} else {
					this.postTip = false;
				}
				if (!this.cardImg) {
					this.cardImgTip = true;
					return false;
				} else {
					this.cardImgTip = false;
				}
				if (!this.carousels.length) {
					this.carouselsTip = true;
					return false;
				} else {
					this.carouselsTip = false;
				}
				if (!this.infoPic.length) {
					this.infoPicTip = true;
					return false;
				} else {
					this.infoPicTip = false;
				}
				if (!this.floatReg.test(this.fare)) {
					this.fareTip = true;
					return false;
				} else {
					this.fareTip = false;
				}
				if (!this.positiveReg.test(this.monthSale)) {
					this.monthSaleTip = true;
					return false;
				} else {
					this.monthSaleTip = false;
				}
				this.add();
			},
			// 新增
			add() {
				const that = this;
				that.loading = true;
				let requestData = {
					goodsName: that.name,
					goodsSmallIcon: that.post,
					goodsPrice: that.oldPrice,
					goodsDiscountPrice: that.price,
					carouselMap: that.carousels.join(','),
					virtual: that.isVirtual,
					freight: that.fare,
					productId: that.trainingProduct,
					goodsDesc: that.desc,
					goodsImgs: that.infoPic.join(','),
					goodsVideo: '',
					goodsDiseases: that.disease.join(','),
					times: that.times,
					days: that.days,
					cardImg: that.cardImg,
					typeChannel: 2,
					goodsFactoryPrice: that.factoryPrice,
					monthlySales: that.monthSale
				};
				Api.addGoodsForAppAndMall(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.$message.success(res.data.message);
						that.selfDisplay = false;
						that.$emit('onSuccess');
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display(newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay(newVal) {
				this.$emit("changeDisplay", newVal);
				if (!newVal) {
					this.loading = false;
					this.uploadType = '';
					this.name = '';
					this.desc = '';
					this.oldPrice = '';
					this.factoryPrice = '';
					this.price = '';
					this.isVirtual = 1;
					this.days = '';
					this.times = '';
					this.trainingProduct = '';
					this.disease = [];
					this.post = '';
					this.cardImg = '';
					this.carousels = [];
					this.infoPic = '';
					this.fare = '';
					this.monthSale = '';
					this.nameTip = false;
					this.descTip = false;
					this.oldPriceTip = false;
					this.factoryPriceTip = false;
					this.priceTip = false;
					this.daysTip = false;
					this.timesTip = false;
					this.trainingProductTip = false;
					this.diseaseTip = false;
					this.postTip = false;
					this.cardImgTip = false;
					this.carouselsTip = false;
					this.infoPicTip = false;
					this.fareTip = false;
					this.monthSaleTip = false;
				}
			}
		}
	}
</script>

<style>
</style>
